import { DeploymentDate, Deployment } from '../types/types';

export const extractDeploymentNumber = (
  deploymentString: string
): number | null => {
  const match = deploymentString.match(/^Deployment_(\d+)$/);
  if (match) {
    return parseInt(match[1], 10);
  } else {
    console.error('Invalid format');
    return null;
  }
};

export const findDeploymentByDate = (
  targetDate: string,
  deploymentDates: DeploymentDate[]
) => {
  const foundDeployment = deploymentDates.find(
    (deployment) => deployment.date === targetDate
  );

  if (foundDeployment) {
    return foundDeployment;
  } else {
    return null;
  }
};

export const extractDeployment = (url: string) => {
  const parts = url.split('/');
  return parts.length > 6 ? parts[5] : 'Unknown Deployment';
};

export const extractDateFromDeployment = (
  deployment: string | Deployment
): string => {
  if (typeof deployment === 'string') {
    const match = deployment.match(/(\d{4}-\d{2}-\d{2})/);
    return match ? match[1] : deployment;
  } else if ('date' in deployment) {
    return deployment.date;
  }
  return '';
};
